<h1 mat-dialog-title>Regcheq</h1>
<div mat-dialog-content>
    <div class="mat-table-container">
        <table mat-table [dataSource]="dataSource">
            <mat-text-column name="ruc"></mat-text-column>
            <mat-text-column name="delito"></mat-text-column>
            <mat-text-column name="riesgo"></mat-text-column>
            <mat-text-column name="fechaInicial" headerText="Fecha Inicial"></mat-text-column>
            <mat-text-column name="fechaUltimoMov" headerText="Fecha Ultimo Mov"></mat-text-column>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <tr class="mat-mdc-row" *matNoDataRow>
                <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="displayedColumns.length">
                    No hay datos disponibles
                </td>
            </tr>
        </table>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cerrar</button>
</div>
